export default function headerEntryMenu() {
  const entry = document.querySelector(".js-header-entry");
  if (!entry) return;

  const button = entry.querySelector(".js-header-entry-btn");
  const panel = entry.querySelector(".js-header-entry-btns");
  if (!button || !panel) return;

  const close = () => entry.classList.remove("is-open");
  const open = () => entry.classList.add("is-open");
  const toggle = () => entry.classList.toggle("is-open");

  const canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  const isTouchLike = window.matchMedia("(hover: none) and (pointer: coarse)").matches;

  // PC: hoverでis-openを付け外し（クリックでは開閉しない）
  if (canHover) {
    entry.addEventListener("mouseenter", () => open());
    entry.addEventListener("mouseleave", () => close());
  }

  // Touch: ボタンタップで開閉
  if (isTouchLike) {
    button.addEventListener("click", (e) => {
      e.stopPropagation();
      toggle();
    });

    // パネル内クリックでは閉じない
    panel.addEventListener("click", (e) => {
      e.stopPropagation();
    });

    // 外側クリックで閉じる
    document.addEventListener("click", () => {
      close();
    });
  }

  // Escで閉じる
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });
}

